import PersonIcon from '@material-ui/icons/Person';
import { ChallengeProgressEdit } from './views';

export default {
  edit: ChallengeProgressEdit,
  icon: PersonIcon,
  name: 'user-challenge-report',
};
